import { Controller } from "@hotwired/stimulus"

// Shows/hides fields when a checkbox is toggled (e.g. show coach contact -> show coach phone field)
export default class extends Controller {
  static targets = ["trigger", "target"]

  connect() {
    this.triggerTarget.addEventListener("change", this._toggle.bind(this))
    this._toggle()
  }

  _toggle() {
    const show = this.triggerTarget.checked
    this.targetTarget.classList.toggle("d-none", !show)
  }
}
